import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { WebStorage } from '../../services/web-storage';
import { Auth } from '../../services/auth';
import { Router } from '@angular/router';
import { Common } from '../../services/common';

@Component({
  selector: 'app-role-select',
  imports: [CommonModule, FormsModule],
  templateUrl: './role-select.html',
  styleUrl: './role-select.scss',
})
export class RoleSelect {
  user: any;
  roles: string[] = [];
  selectedRole: string | null = '';

  constructor(private webStorageService: WebStorage, private authService: Auth,
    private router: Router, private commonService: Common) {
    this.user = this.webStorageService.retrieveItem('cu');
    this.roles = this.user?.roles || [];
    this.roles = this.orderRoles(this.roles);
  }

  ngOnInit() {
    console.log('User in RoleSelect component:', this.user);
    if (this.user.role !== null && this.user.role !== undefined && this.user.role !== '') {
      this.navigateByRole(this.user.role);
    }
  }

  orderRoles(roles: string[]): string[] {
    const roleOrder = ['flms', 'supervisors', 'riskofficers'];
    return roles.sort((a, b) => roleOrder.indexOf(a.toLowerCase()) - roleOrder.indexOf(b.toLowerCase()));
  }

  setRole() {
    if (this.selectedRole) {
      console.log('Selected role:', this.selectedRole);
      this.user.role = this.selectedRole.toLowerCase();
      this.webStorageService.storeItem('cu', this.user);
      this.navigateByRole(this.selectedRole.toLowerCase());
    }
  }

  navigateByRole(role: string) {
    const path = this.commonService.getNavigateByRole(role);
    this.router.navigate([path]);
  }

  logout() {
    console.log('Logging out...');
    this.authService.initiateLogout();
  }
}
